module.exports = __webpack_public_path__ + "img/icon_leader.f65c5069.png";